import { _breakP } from './utils.js';
export default class acod {
  constructor() {
    this.acodFunc();
  }

  acodFunc() {
    const $acod = document.querySelectorAll('.js-acod');

    if ($acod.length) {
      $acod.forEach((elm) => {
        const $acodBtn = elm.querySelector('.js-acodBtn'),
          $acodBody = elm.querySelector('.js-acodBody');

        function acodToggle() {
          $acodBtn.addEventListener('click', () => {
            $acodBtn.classList.toggle('is-active');
            $acodBody.classList.toggle('is-active');
          });
        }

        if (elm.dataset.modalDevice === 'sp') {
          _breakP.SP ? acodToggle() : null;
        } else if (elm.dataset.modalDevice === 'pc') {
          !_breakP.SP ? acodToggle() : null;
        } else {
          acodToggle();
        }
      });
    }
  }
}
